import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-back-button',
  template: `
  <a>
  <button type="button" class="btnLogo"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Go Back </button>
  </a>
  `,
  styles: [
  ]
})
export class BackButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
